import gql from 'graphql-tag';

const createShoppingCart = gql`
  mutation createPdfPreview($shoppingCart: ShoppingCartInput!) {
    generatePDF(shoppingCart: $shoppingCart)
  }
`;

export default createShoppingCart;
